export default __webpack_public_path__ + "c2e0d720ec3f7c8b2851fefe4245a65d.jpg";